export function joinClassNames(...values) {
    return values.filter(Boolean).join(" ");
}
